export default __webpack_public_path__ + "static/media/sinpe-movil-logo.c7fcf626.png";